export default __webpack_public_path__ + "static/media/img_declaration_promise1.70949b20.png";